import React from "react";
import "./Breadcrum.css";
import arrow_icon from "../Assets/breadcrum_arrow.png";

const Breadcrum = (props) => {
  const { product } = props;
  // console.log(product);
  return (
    <div className="breadcrum">
      Home <img src={arrow_icon} /> SHOP <img src={arrow_icon} />
      {product.category} <img src={arrow_icon} />
      {product.name}
    </div>
  );
};

export default Breadcrum;
